import { nmDisplaySetSelector } from '@common';
import { ServicesManager } from '@core';

/**
 * Kiểm tra xem Study có chứa dữ liệu Y học hạt nhân (NM hoặc PT) hay không.
 */
export const isNuclearMedAvailable = (servicesManager: ServicesManager): boolean => {
    const { hangingProtocolService } = servicesManager.services;

    // ptDisplaySetSelector đã check ca có phải là PT hay NM hay không
    const ptSeries = hangingProtocolService.matchImages(nmDisplaySetSelector);

    // Chỉ cần có ít nhất 1 series khớp là đủ điều kiện mở mode NM
    return !!(ptSeries.matchingScores && ptSeries.matchingScores.length > 0);
};